import React from 'react'
import { IButtonProps } from '../types'
import styles from './styles.module.scss'
import clsx from 'clsx'

// A dev base for all buttons, not to be called into apps directly
const ButtonBase = React.forwardRef<HTMLButtonElement, IButtonProps>(
  (
    { children, isLoading = false, size = 'md', type = 'button', className = '', ...props },
    ref,
  ) => {
    return (
      <button
        data-testid="mui-button"
        ref={ref}
        type={type}
        {...props}
        className={clsx(
          'mui-button',
          styles.button,
          styles[size],
          { [styles.loading]: isLoading },
          className,
        )}
      >
        {children}
      </button>
    )
  },
)

export default ButtonBase
